module.exports = __webpack_public_path__ + "img/4.a5503d52.jpg";